import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import moment from 'moment';
import { Box, Dialog, DialogActions, DialogContent as MuiDialogContent, DialogTitle, FormControl, Grid, IconButton, InputAdornment as MuiInputAdornment, Typography, withStyles } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { KailonaButton, KailonaDateTimePicker, KailonaTextField } from '@kailona/ui';
var DialogContent = withStyles({
  root: {
    height: '100%',
    margin: '0 20px 20px 20px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #EAEAEA',
    borderRadius: '5px',
    paddingBottom: '25px'
  }
})(MuiDialogContent);
var InputAdornment = withStyles({
  root: {
    '& p': {
      fontSize: '10px'
    }
  }
})(MuiInputAdornment);
var GridColumn = withStyles({
  root: {
    '&.left-column': {
      margin: '10px 10px 10px 0',
      width: '180px'
    },
    '&.right-column': {
      margin: '10 0px 10px 10px',
      width: '180px'
    },
    '& > .MuiFormControl-root': {
      width: '100%'
    }
  }
})(Grid);

var ActivitiesEditModal = /*#__PURE__*/function (_Component) {
  _inherits(ActivitiesEditModal, _Component);

  var _super = _createSuper(ActivitiesEditModal);

  function ActivitiesEditModal(props) {
    var _this;

    _classCallCheck(this, ActivitiesEditModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function (isOpen) {
      _this.setState({
        isOpen: isOpen
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onConfirm", function () {
      var newActivitiesData = {
        datePeriod: {
          start: moment(_this.dateStartRef.current.value),
          end: moment(_this.dateEndRef.current.value)
        },
        steps: _this.stepsRef.current.value,
        distance: _this.distanceRef.current.value,
        calories: _this.caloriesRef.current.value
      };
      var activitiesData = _this.props.activitiesData;

      _this.props.handleSave(Object.assign({}, activitiesData || {}, newActivitiesData));
    });

    _defineProperty(_assertThisInitialized(_this), "getValue", function (text) {
      if (!text || !text.split) {
        return text || '';
      }

      var _text$split = text.split(' '),
          _text$split2 = _slicedToArray(_text$split, 1),
          value = _text$split2[0];

      return value;
    });

    _this.state = {
      isOpen: false
    };
    _this.dateStartRef = /*#__PURE__*/React.createRef();
    _this.dateEndRef = /*#__PURE__*/React.createRef();
    _this.stepsRef = /*#__PURE__*/React.createRef();
    _this.distanceRef = /*#__PURE__*/React.createRef();
    _this.caloriesRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(ActivitiesEditModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _ref = this.props.activitiesData || {},
          datePeriod = _ref.datePeriod,
          steps = _ref.steps,
          distance = _ref.distance,
          calories = _ref.calories;

      var _ref2 = datePeriod || {},
          dateStart = _ref2.start,
          dateEnd = _ref2.end;

      return /*#__PURE__*/React.createElement(Dialog, {
        open: this.state.isOpen,
        onClose: function onClose() {
          return _this2.toggleModal(false);
        }
      }, /*#__PURE__*/React.createElement(DialogTitle, null, /*#__PURE__*/React.createElement(Box, {
        display: "flex",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Box, {
        flexGrow: 1
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h3"
      }, t('ehr', this.props.activitiesData ? 'Update Activity' : 'Add New Activity'))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(IconButton, {
        onClick: function onClick() {
          return _this2.toggleModal(false);
        }
      }, /*#__PURE__*/React.createElement(CloseIcon, null))))), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(GridColumn, {
        item: true,
        className: "left-column"
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaDateTimePicker, {
        inputRef: this.dateStartRef,
        id: "dateStart",
        ariaLabel: t('ehr', 'Start Date/Time'),
        defaultValue: dateStart ? moment(dateStart) : null,
        disableFuture: true
      }))), /*#__PURE__*/React.createElement(GridColumn, {
        item: true,
        className: "right-column"
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaDateTimePicker, {
        inputRef: this.dateEndRef,
        id: "dateEnd",
        ariaLabel: t('ehr', 'End Date/Time'),
        defaultValue: dateEnd ? moment(dateEnd) : null,
        disableFuture: true
      })))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(GridColumn, {
        className: "left-column",
        item: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaTextField, {
        inputRef: this.stepsRef,
        id: "steps",
        className: "kailona-MuiTextField",
        label: t('ehr', 'Steps'),
        defaultValue: this.getValue(steps)
      }))), /*#__PURE__*/React.createElement(GridColumn, {
        className: "right-column",
        item: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaTextField, {
        inputRef: this.distanceRef,
        type: "number",
        id: "distance",
        className: "kailona-MuiTextField",
        label: t('ehr', 'Distance'),
        defaultValue: this.getValue(distance),
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, null, "m")
        }
      })))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(GridColumn, {
        className: "left-column",
        item: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaTextField, {
        inputRef: this.caloriesRef,
        type: "number",
        id: "calories",
        className: "kailona-MuiTextField",
        label: t('ehr', 'Calories'),
        defaultValue: this.getValue(calories),
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, null, "cal")
        }
      })))))), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(KailonaButton, {
        title: t('ehr', 'Cancel'),
        class: "default",
        disabled: this.props.savingActivities,
        onClick: function onClick() {
          return _this2.toggleModal(false);
        }
      }), /*#__PURE__*/React.createElement(KailonaButton, {
        title: t('ehr', 'Confirm'),
        class: "primary",
        disabled: this.props.savingActivities,
        onClick: this.onConfirm,
        loading: this.props.savingActivities
      })));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return ActivitiesEditModal;
}(Component);

export { ActivitiesEditModal as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DialogContent, "DialogContent", "/home/runner/html/nextcloud/apps/ehr/js/plugins/activities/src/components/ActivitiesEditModal.js");
  reactHotLoader.register(InputAdornment, "InputAdornment", "/home/runner/html/nextcloud/apps/ehr/js/plugins/activities/src/components/ActivitiesEditModal.js");
  reactHotLoader.register(GridColumn, "GridColumn", "/home/runner/html/nextcloud/apps/ehr/js/plugins/activities/src/components/ActivitiesEditModal.js");
  reactHotLoader.register(ActivitiesEditModal, "ActivitiesEditModal", "/home/runner/html/nextcloud/apps/ehr/js/plugins/activities/src/components/ActivitiesEditModal.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();